/**
 * NODE UTILITIES
 * 
 * Handles node dimension calculations and categorization.
 * Computes heights based on content and determines node types.
 */

import {
  NODE_MIN_HEIGHT, NODE_MAX_HEIGHT,
  NODE_PADDING, HEADER_HEIGHT, PREVIEW_BUTTON_HEIGHT,
  TITLE_FONT_SIZE, TEXT_FONT_SIZE, LINE_HEIGHT, CHARS_PER_LINE,
} from '../../../../Config/ExistingVisaTreeViewConsts.js';

import { cleanText, wrapText } from './text.js';

// ── Line Counting ────────────────────────────────────────────────────────

export const countLines = (text, max = 2) =>
  text ? Math.min(max, wrapText(text, CHARS_PER_LINE).length) : 0;

// ── Node Height Calculation ──────────────────────────────────────────────

export const calculateNodeHeight = (node) => {
  const title = cleanText(node.title);
  const text = cleanText(node.text);

  let h = HEADER_HEIGHT + NODE_PADDING * 2 + PREVIEW_BUTTON_HEIGHT;
  
  if (title) {
    h += countLines(title) * (TITLE_FONT_SIZE * LINE_HEIGHT);
  }
  
  if (text) {
    h += countLines(text) * (TEXT_FONT_SIZE * LINE_HEIGHT) + (title ? 4 : 0);
  }

  return Math.min(
    NODE_MAX_HEIGHT + PREVIEW_BUTTON_HEIGHT,
    Math.max(NODE_MIN_HEIGHT, Math.ceil(h))
  );
};

// ── Node Categorization ──────────────────────────────────────────────────
export const getNodeCategory = (node, hasChildren = true) => {
  if (node.type === 'ROOT_NODE') return 'start';
  if (node.type === 'DECISION_NODE') return 'decision';
  if (node.type === 'END_NODE') return 'outcome';
  return hasChildren ? 'decision' : 'outcome';
};
